export const enum ImageDecorationPosition {
    TopLeft = 'top-left',
    TopRight = 'top-right',
    BottomLeft = 'bottom-left',
    BottomRight = 'bottom-right',
}

export const ShowIconsOnFocused = {
    All: 'all',
    None: 'none',
    Interactive: 'interactive',
} as const;

export type ShowIconsOnFocused =
    (typeof ShowIconsOnFocused)[keyof typeof ShowIconsOnFocused];
